import React, { useState } from 'react';

import { ActionIcon, Button, Group, Space, Text, TextInput, Title, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconPlus, IconSearch, IconX } from '@tabler/icons-react';
import PageHeader from 'components/PageHeader';
import { useAuth } from 'context/auth-context';

import DrawerPackageCategoryForm from './components/DrawerPackageCategoryForm';
import PackageCategoryTableContainer from './components/PackageCategoryTableContainer';

const PackageCategory = (): JSX.Element => {
  const { hasPerm } = useAuth();
  const theme = useMantineTheme();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [addCategory, { open, close }] = useDisclosure(false);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget?.value || '';
    setSearchTerm(value);
  };
  const handleClearSearchFilter = (): void => {
    setSearchTerm('');
  };

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Group>
            <Title order={1} size='h1'>
              Package Categories
            </Title>
            <Text c='dimmed'>Manage your gym packages</Text>
          </Group>
          <Group noWrap>
            <TextInput
              icon={<IconSearch size={theme.fontSizes.md} />}
              placeholder='Search'
              value={searchTerm}
              onChange={handleSearchChange}
              rightSection={
                !!searchTerm ? (
                  <ActionIcon onClick={handleClearSearchFilter} size='md'>
                    <IconX size={theme.fontSizes.md} />
                  </ActionIcon>
                ) : (
                  <Space />
                )
              }
            />
            <Button
              leftIcon={<IconPlus size={theme.fontSizes.md} />}
              onClick={open}
              disabled={!hasPerm('PackageMutate')}
            >
              Category
            </Button>
          </Group>
        </Group>
      </PageHeader>
      <PackageCategoryTableContainer searchTerm={searchTerm} permission={hasPerm('PackageMutate')} />
      <DrawerPackageCategoryForm
        formId='add-package-category-form'
        title={
          <Text size='lg' weight='bold'>
            Add Package Category
          </Text>
        }
        opened={addCategory}
        closeHandler={close}
        type='create'
        permission={hasPerm('PackageMutate')}
      />
    </>
  );
};

export default PackageCategory;
